import { FormlyFieldConfig } from '@ngx-formly/core';

export const checkboxInputForm: FormlyFieldConfig[] = [
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        key: 'defaultValue',
        type: 'select',
        defaultValue: false,
        props: {
          translate: true,
          label: 'formGenerator.uiElement.toggle.defaultValue',
          options: [
            {
              name: 'false',
              id: false,
            },
            {
              name: 'true',
              id: true,
            },
          ],
        },
      },
    ],
  },
];
